<template>
  <v-container fluid>
    <v-row dense class="d-flex mb-0 pb-0" style="height: 50px">
      <!-- View Title -->
      <v-col class="d-flex mt-1 mb-0 pb-0 ml-2" md="auto">
        <ViewTitle title="BusinessProcess" />
      </v-col>
      <v-col class="d-flex mb-0 pb-0" >
        <v-btn
          rounded
          small
          class="add-button"
          @click.stop="addBPForm()"
          >
            Add BP
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="d-flex justify-end mb-0 pb-0 component" md="auto">
        <SearchTextTable @input="setSearchText" />
      </v-col>
      <!-- <v-spacer></v-spacer> -->
      <v-col cols="1"></v-col>

    </v-row>
    <v-data-table
      :headers="bpColumns"
      :items="items"
      show-expand
      dense
      item-key="id"
      :search="search"
    >
    <!-- Actions -->
    <template v-slot:[`item.action`]="{ item }">
      <v-btn 
        small
        icon
        @click="downloadBusinessProcess(item)"
      >
        <v-icon small>mdi-download</v-icon>        
      </v-btn>
      <v-btn 
        v-if="item.site_path===sitePath"
        small
        icon
        @click="updateBusinessProcess(item)"
      >
        <v-icon small>mdi-pencil</v-icon>
        
        </v-btn>
    </template>
          <!-- Expanded -->
      <template v-slot:expanded-item="{ item }">
        <td :colspan="bpColumns.length +1"
          class="qmkey-explorer-table-expansion-td"
        >
          <!-- needed to use row length -->
          <v-container fluid>
              <v-tabs
                v-model="tabs"
                icons-and-text
                align-with-title
                background-color="#cac8c9"
                height="32"
                class="qmkey-explorer-table-expansion-panel"
                active-class="qmkey-explorer-table-expansion-panel-active"
              >
                <v-tab
                  v-if="item.description"
                  class="qmkey-explorer-table-expansion-panel-header"
                >
                  <div class="tab">
                    BP Description
                  </div>
                </v-tab>
                <v-tab
                  class="qmkey-explorer-table-expansion-panel-header"
                >
                  <div class="tab">
                    BP Nav
                  </div>
                </v-tab>
              </v-tabs>
              <v-tabs-items
                v-model="tabs"
              >
                <!-- TODO -->
                <v-tab-item
                  v-if="item.description"
                  class=""
                >
                  <span class="text body-2">{{ item.description }}</span>
                </v-tab-item>
                <!-- TODO -->
                <v-tab-item
                  class=""
                >
                  <v-json-tree 
                    :jsonData="JSON.parse(item.business_process)"
                    :fullMarkup="true"                    
                  >
                  </v-json-tree>
                </v-tab-item>
              </v-tabs-items>

          </v-container>
        </td>
      </template>
    </v-data-table>
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      @close-dialog="toggle_dialog"
      @submit="submit_action"
      :message="message"
    >
    </modal-dialog-form>
  </v-container>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import QBusinessprocess from '@/api/Businessprocess'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import vJsonTree from './JsonTree.vue'
import SearchTextTable from '@/components/SearchTextTable'

export default {
  components: { ViewTitle, ModalDialogForm, vJsonTree, SearchTextTable },
  name: 'BPExplorerTable',
  data(){
    return {
      bpColumns:[
        { 
          text: 'Reference',
          value: 'reference',
        },
        { 
          text: 'Name',
          value: 'name',
        },
        { 
          text: 'Type',
          value: 'type',
        },
        { 
          text: 'Site',
          value: 'site',
        },
        {
          value: 'action',
          text: 'Actions',
          filterable: false,
          sortable: false,
        },
        {
          value: 'data-table-expand',
          text: '',
          filterable: false,
          sortable: false,
        }
      ],
      items: [],
      fileType: "json",
      showModalDialog: false,
      valid: null,
      loading: false,
      addModalDialog: null,
      modal_title:'',
      submit_button_caption:'',
      fields_to_collect:[
        [{
          id:	"json_file",
          label:	"BP",
          required:	true,
          value:	null,
          readonly:	false,
          hidden:	null,
          cols:	4,
          class:	null,
          component:	"FileInput",
          placeholder:"Select File",
          accept: ".json",
        }]
      ],
      tabs: null,
      message: "",
      search: "",
      submit_action: function () {},
      currentBP: {},
    }
    
  },
  filters: {
    pretty: function(value) {
      console.log("prety")
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
  computed: {
    ...mapState(['isLoading', 'sitePath']),
    ...mapState([]),
  },
  mounted: function() {
    this.getBusinessProcesses()    
  },
  methods: {
    getBusinessProcesses(){
      QBusinessprocess.get(this.sitePath)
      .then(response => {
          this.items = response.results
          // this.items = {}          
        })
        .catch(err => {
          console.log(err)
        })
    },
    downloadBusinessProcess(item) {
      let content = item.business_process;
      if (content === null) {
        this.$emit("error");
        return;
      }
      // if (this.confirm !== null) {
      //   const result = confirm(this.confirm);
      //   if (!result) return;
      // }
      let fileName = `${item.reference}_${item.site}`
      const blob = new Blob([content], {
        type: `application/${this.fileType}`
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.${this.fileType}`;
      link.click();
      this.$emit("success");
    },
    // Forms
    addBPForm() {
      this.currentBP = {}
      this.modal_title = 'Add new BusinessProcess'
      this.showModalDialog = true
      this.currentBP.path = this.sitePath      
      this.submit_button_caption = 'Add'
      this.submit_action = this.addBP
    },
    updateBusinessProcess(item){
      this.showModalDialog = true
      this.currentBP = item
      // TODO:Lang
      this.modal_title = 'Update ' + item.name
      this.submit_button_caption = 'Save'
      this.submit_action = this.uploadBP
    },
    toggle_dialog() {
      this.showModalDialog = false      
    },
    process_form: function (form_data) {      
      console.log('BPExplorer, form submit', form_data)
      this.uploadBP(form_data)
    },
    addBP(form_data){
      console.log("adddBP", this.sitePath)
      QBusinessprocess.post(this.sitePath, form_data)
        .then(() => {
          this.getBusinessProcesses()
          console.log('ok')
          let currentBP = {}
          this.modal_title = ''
          this.showModalDialog = false
          this.submit_button_caption = ''
          this.message = ''
          this.submit_action = function () {}
          // this.$root.$loader.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
          console.log(err, err.response)
          // this.message = err
        })
    },
    uploadBP(form_data){
      console.log("uploadBP", this.sitePath)
      QBusinessprocess.put(this.sitePath, this.currentBP.reference, form_data)
        .then(() => {
          this.getBusinessProcesses()
          console.log('ok')
          this.currentBP = {}
          this.modal_title = ''
          this.showModalDialog = false
          this.submit_button_caption = ''
          this.message = ''
          this.submit_action= function () {}
          // this.$root.$loader.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
          console.log(err, err.response)
          // this.message = err
        })
    },
    setSearchText(text){
      console.log("setSearchText", text)
      this.search = text
      
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/explorer.scss';
</style>